import React, { createContext, useEffect, useMemo, useState } from 'react'
import Header from './Header'
import { pulldowns } from 'store/hooks'
import { useSelector } from 'react-redux'
import { affiliationGroups } from 'keys'
import { useQuery } from '@tanstack/react-query'
import { getAffiliationsFetch } from 'store/middlewares/affiliation.crud'
import qc from 'keys/queryClient'

const HeaderComponent = (props) => {
    const { isExpanded, headerFilters } = useSelector(state => state.header)
    const { roleIndex } = useSelector(state => state.user)

    const handleGroup = pulldowns.useHandleGroup()
    const handleGrade = pulldowns.useHandleGrade()
    const handleAffiliation = pulldowns.useHandleAffiliation()
    const cleanSchoolClassess = pulldowns.useCleanSchoolClassess()
    const cleanLearningGroups = pulldowns.useCleanLearningGroups()

    const affiliations = useQuery({
        queryKey: [qc.affiliations],
        queryFn: async () => {
            const { data } = await getAffiliationsFetch()
            return data
        },
        enabled: isExpanded
    })

    useEffect(() => {
        if (headerFilters.affiliation && headerFilters.grade)
            handleGrade(headerFilters)
        else cleanSchoolClassess()
    }, [headerFilters, roleIndex])
    useEffect(() => { handleGroup(headerFilters) }, [headerFilters.group, roleIndex])
    useEffect(() => {
        if (headerFilters.affiliation && headerFilters.affiliation?.group_name != affiliationGroups.schools)
            handleAffiliation(headerFilters)
        else cleanLearningGroups()
    }, [headerFilters, roleIndex])

    const commonState = useMemo(() => ({
        isExpanded,
        affiliations
    }), [isExpanded, affiliations])

    return (
        <HeaderContext.Provider value={commonState}>
            <Header {...props} />
        </HeaderContext.Provider>
    )
}

export const HeaderContext = createContext()
export default HeaderComponent